import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';

import { CwCard, CwIcon } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { ROUTES } from '@shared/constants/routes/routes.constants';
import { UserInfo } from '@shared/interfaces/user/user-info.interface';
import { SmallHeaderComponent } from '@shared/small-header/small-header.component';
import { UserFacade } from '@store/user/user.facade';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-role',
  imports: [CommonModule, RouterModule, SmallHeaderComponent, CwCard, CwIcon, TranslocoDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './user-role.component.html',
  styleUrls: ['./user-role.component.sass']
})
export class UserRoleComponent implements OnInit {
  public readonly user = signal<UserInfo | undefined>(undefined);
  public ROUTES = ROUTES;
  public loading$!: Observable<boolean>;

  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly userFacade = inject(UserFacade);

  public ngOnInit(): void {
    this.loading$ = this.userFacade.loading;
    this.userFacade.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user: UserInfo) => {
      this.user.set(user);
      if (user.user && !user.admin) {
        this.router?.navigateByUrl(ROUTES.COMBINATIONS);
      }
    });
  }
}
